/**
 * configurationsreducer.js
 * Created by calhosh on 8/27/2020.
 */
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';

export default function ConfigurationsReducer(state = initialState.configurations, action) {
	switch (action.type) {
		case types.GET_CONFIGURATIONS: {
			return {
				...action.response,
				isAutomationHubEnabled: !!_.get(action, 'response.features.automationHub')
			};
		}
		default:
			return state;
	}
}

export function getIsAutomationHubEnabled(state) {
	return state.configurations?.isAutomationHubEnabled;
}
